export default {
  slug: "gateway",
  code: "GW",
  label: "Gateway",
  logoFamily: "jb",
};
